/*eslint-disable*/
import React, { useState, useEffect } from 'react';
import { useTable, useFilters, useSortBy, usePagination } from 'react-table';
import classnames from 'classnames';
// A great library for fuzzy filtering/sorting items
import matchSorter from 'match-sorter';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
// core components
import CustomInput from 'components/CustomInput/CustomInput.js';
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Button from 'components/CustomButtons/Button.js';
import moment from 'moment';

import styles from 'assets/jss/material-dashboard-pro-react/customSelectStyle.js';
import { ChevronLeftRounded, ChevronRightRounded, ViewComfy } from '@material-ui/icons';

import ReactExport from 'react-data-export';
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const newStyles = {
  ...styles,
  formControlMargins: {
    margin: '3px 0 !important',
  },
  gridContainer: {
    justifyContent: 'center',
  },
};

const useStyles = makeStyles(newStyles);

// Define a default UI for filtering
function DefaultColumnFilter({ column: { filterValue, preFilteredRows, setFilter } }) {
  const count = preFilteredRows.length;

  return (
    <CustomInput
      formControlProps={{
        fullWidth: true,
      }}
      inputProps={{
        value: filterValue || '',
        onChange: (e) => {
          setFilter(e.target.value || undefined); // Set undefined to remove the filter entirely
        },
        placeholder: `Bucar primeros ${count} ...`,
      }}
    />
  );
}

function fuzzyTextFilterFn(rows, id, filterValue) {
  return matchSorter(rows, filterValue, { keys: [(row) => row.values[id]] });
}

// Let the table remove the filter if the string is empty
fuzzyTextFilterFn.autoRemove = (val) => !val;

// Our table component
export default function Table(props) {
  const {
    columns, //le quite de aqui para formatear las fechas
    /* data, */ pagination = true,
    filter = true,
    defaultWidth,
    heightRow,
    firstColumn,
    formatDate,
    widthRow = [],
    indexRow = [],
    colorRow,
    alignColumn = [],
    indexColumn = [],
    exportExcel = true,
    showHeader = true,
    fullPagination = false,
    headerExcel = [],
    valueExcel = [],
  } = props;

  const [data, setData] = useState([]);

  //#region Propiedades de la tabla
  const [numberOfRows, setNumberOfRows] = React.useState(10);
  const [pageSelect, handlePageSelect] = React.useState(0);
  const classes = useStyles();
  const paginationState = pagination == true ? {} : { display: 'none' };

  const filterTypes = React.useMemo(
    () => ({
      // Add a new fuzzyTextFilterFn filter type.
      fuzzyText: fuzzyTextFilterFn,
      // Or, override the default text filter to useF
      // "startWith"
      text: (rows, id, filterValue) => {
        return rows.filter((row) => {
          const rowValue = row.values[id];
          return rowValue !== undefined
            ? String(rowValue).toLowerCase().startsWith(String(filterValue).toLowerCase())
            : true;
        });
      },
    }),
    [],
  );

  const defaultColumn = React.useMemo(
    () => ({
      // Let's set up our default Filter UI
      Filter: DefaultColumnFilter,
    }),
    [],
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    state,
    visibleColumns,
    nextPage,
    pageOptions,
    pageCount,
    previousPage,
    canPreviousPage,
    canNextPage,
    setPageSize,
    gotoPage,
  } = useTable(
    {
      columns,
      data,
      defaultColumn,
      filterTypes,
      initialState: { pageSize: fullPagination ? 10000 : 10, pageIndex: pageSelect },
      autoResetFilters: false,
    },
    useFilters,
    useSortBy,
    usePagination,
  );

  let pageSelectData = Array.apply(null, Array(pageOptions.length)).map(function () {});
  let numberOfRowsData = [10, 20, 25, 50, 100, 200];
  //#endregion

  //#region Formado de fecha para la columas de la tabla
  function formatDateColum() {
    let data = props.data.map((item) => {
      let obj = { ...item };
      let formats = [
        moment.ISO_8601,
        // 'DD-MM-YYYY',
        'YYYY-MM-DD',
        'DD-MM-YYYY H:mm:ss',
        'YYYY-MM-DD H:mm:ss',
      ]; //poner aqui los formatos que esperas pasar

      for (let key in item) {
        delete item['num'];
        delete item['actions'];
        if (moment(item[key], formats, true).isValid() && isNaN(item[key])) {
          obj[key] = moment(item[key]).format(!!formatDate ? formatDate : 'DD-MM-YYYY H:mm:ss');
        }
      }
      return obj;
    });
    formatDataExport(data);

    let hiddenColumns = columns
      .filter((column) => column.hidden === true)
      .map((column) => column.accessor);

    let formatNumberData = data.map((item) => {
      let obj = { ...item };
      for (let key in item) {
        // Quitando columnas ocultas
        if (hiddenColumns.includes(key)) {
          delete obj[key];
          continue;
        }

        if (item[key] === null || item[key] === '' || item[key] === undefined) continue;

        if (!isNaN(item[key])) {
          if (Number.isInteger(item[key])) {
            obj[key] = item[key]?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          } else if (typeof item[key] !== 'string') {
            let parsed = parseFloat(item[key]).toFixed(2);
            let newNumber = parsed?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            obj[key] = newNumber;
          }
        }
      }
      return obj;
    });
    setData(formatNumberData);
  }
  //#endregion

  //#region formateo de data para exportar a excel
  const [dataEx, setDataEx] = useState([]);
  const [columnEx, setColumEx] = useState([]);

  function formatDataExport(data) {
    let cabeceras = {};
    for (let keyColumEx of columnEx) {
      if (keyColumEx.accessor !== '') {
        cabeceras[keyColumEx.accessor] = 0;
      }
      if (data.length > 0) {
        for (let row of data) {
          if (keyColumEx.accessor !== '') {
            if (!!row[keyColumEx.accessor]) {
              if (row[keyColumEx.accessor].length > cabeceras[keyColumEx.accessor]) {
                cabeceras[keyColumEx.accessor] = row[keyColumEx.accessor].length;
              }
            }
          }
        }
      }
    }
    let columnsExcel = formatColumnsExport(cabeceras);
    const colArray = columnsExcel.map((column) => {
      return column.accessor;
    });

    const newData = data.map((item) => {
      let obj = {};
      for (let key in item) {
        if (colArray.includes(key)) {
          obj[key] = item[key];
        }
      }
      return obj;
    });

    let newFormatData = newData.map((item) => {
      let arr = [];

      for (let key in item) {
        let column = columns.find((column) => column.accessor === key);
        let fill = undefined;
        let value = item[key];
        if (!!column && column.isColor === true) {
          fill = { patternType: 'solid', fgColor: { rgb: item[key] } };
          value = '';
        }
        arr.push({
          value: value ?? '',
          style: {
            fill: fill,
            border: {
              top: { style: 'thin' },
              bottom: { style: 'thin' },
              left: { style: 'thin' },
              right: { style: 'thin' },
            },
          },
        });
        if (item[key] === null || item[key] === undefined) continue;

        if (item[key].toString().length > cabeceras[key]) {
          cabeceras[key] = item[key].toString().length;
        }
      }
      return arr;
    });

    setDataEx(newFormatData);
  }

  function formatColumnsExport(cabeceras) {
    let newFormatColumns = props.columns
      .filter((item) => item.excelEnabled !== false)
      .map((item) => {
        return {
          title: item.Header,
          width: {
            wch:
              (item.Header.length > cabeceras[item.accessor]
                ? item.Header.length
                : cabeceras[item.accessor] * 1.1 + 2.5) || 50,
          },
          accessor: item.accessor,
          style: {
            fill: { patternType: 'solid', fgColor: { rgb: 'black' } },
            font: {
              color: { rgb: 'ffffff' },
              bold: true,
              sz: 13,
            },
            alignment: {
              horizontal: 'center',
            },
          },
        };
      });
    setColumEx(newFormatColumns);
    return newFormatColumns;
  }
  //#endregion

  useEffect(() => {
    formatDateColum();
  }, [props.data]);

  /**
   * ? Las cabeceras no usan el textAlign de esta función
   */
  function getCellStyle(i) {
    let maxWidth = '80px';
    let minWidth = '80px';
    let textAlign = 'center';
    if (i === 0) {
      if (indexRow.indexOf(0) !== -1) {
        maxWidth = widthRow[0];
        minWidth = widthRow[0];
      }
      if (indexColumn.indexOf(0) !== -1) {
        textAlign = alignColumn[0];
      }
    } else {
      maxWidth = widthRow[indexRow.findIndex((element) => element === i)];
      minWidth = widthRow[indexRow.findIndex((element) => element === i)];
      textAlign = alignColumn[indexColumn.findIndex((element) => element === i)];
    }

    if (columns[i].width !== undefined) {
      maxWidth = columns[i].width;
      minWidth = columns[i].width;
    }

    if (columns[i].align !== undefined) {
      textAlign = columns[i].align;
    }

    return { maxWidth, minWidth, textAlign };
  }

  return (
    <>
      <div className="ReactTable -striped -highlight">
        <div className="pagination-top">
          <div className="-pagination" style={paginationState}>
            <div className="-previous">
              <Button
                justIcon
                round
                color="primary"
                className={classes.marginRight}
                onClick={() => {
                  gotoPage(pageSelect - 1);
                  handlePageSelect(pageSelect - 1);
                }}
                disabled={!canPreviousPage}
              >
                <ChevronLeftRounded className={classes.icons} />
              </Button>
            </div>
            <div className="-center">
              <GridContainer className={classes.gridContainer}>
                <GridItem xs={12} sm={6} md={6}>
                  <FormControl
                    fullWidth
                    className={classes.selectFormControl + ' ' + classes.formControlMargins}
                  >
                    <Select
                      MenuProps={{
                        className: classes.selectMenu,
                      }}
                      classes={{
                        select: classes.select,
                      }}
                      value={pageSelect}
                      onChange={(event) => {
                        gotoPage(event.target.value);
                        handlePageSelect(event.target.value);
                      }}
                      inputProps={{
                        name: 'pageSelect',
                        id: 'page-select',
                      }}
                    >
                      {pageSelectData.map((prop, key) => {
                        return (
                          <MenuItem
                            key={key}
                            classes={{
                              root: classes.selectMenuItem,
                              selected: classes.selectMenuItemSelected,
                            }}
                            value={key}
                          >
                            Página {key + 1}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </GridItem>
                <GridItem xs={12} sm={6} md={6}>
                  <FormControl
                    fullWidth
                    className={classes.selectFormControl + ' ' + classes.formControlMargins}
                  >
                    <Select
                      MenuProps={{
                        className: classes.selectMenu,
                      }}
                      classes={{
                        select: classes.select,
                      }}
                      value={numberOfRows}
                      onChange={(event) => {
                        setPageSize(event.target.value);
                        setNumberOfRows(event.target.value);
                      }}
                      inputProps={{
                        name: 'numberOfRows',
                        id: 'number-of-rows',
                      }}
                    >
                      {numberOfRowsData.map((prop) => {
                        return (
                          <MenuItem
                            key={prop}
                            classes={{
                              root: classes.selectMenuItem,
                              selected: classes.selectMenuItemSelected,
                            }}
                            value={prop}
                          >
                            {prop} filas
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </GridItem>
              </GridContainer>
            </div>
            <div className="-next">
              <Button
                justIcon
                round
                color="primary"
                className={classes.marginRight}
                onClick={() => {
                  gotoPage(pageSelect + 1);
                  handlePageSelect(pageSelect + 1);
                }}
                disabled={!canNextPage}
              >
                <ChevronRightRounded className={classes.icons} />
              </Button>
            </div>
          </div>
          {exportExcel ? (
            <div>
              <ExcelFile
                element={
                  <Button color="success" size="sm">
                    <ViewComfy /> Excel
                  </Button>
                }
                filename={
                  !!props.excelName
                    ? props.excelName + '_' + moment().format('DD-MM-YYYY')
                    : 'Descarga_' + moment().format('DD-MM-YYYY')
                }
              >
                <ExcelSheet
                  dataSet={[
                    {
                      columns: columnEx,
                      data: dataEx,
                    },
                  ]}
                  name={
                    !!props.excelName
                      ? props.excelName + '_' + moment().format('DD-MM-YYYY')
                      : 'Descarga_' + moment().format('DD-MM-YYYY')
                  }
                />
              </ExcelFile>
            </div>
          ) : undefined}
        </div>
        <table {...getTableProps()} className="rt-table" style={{ overflowY: 'hidden' }}>
          {showHeader ? (
            <thead className="rt-thead -header">
              {headerGroups.map((headerGroup) => (
                <tr
                  {...headerGroup.getHeaderGroupProps()}
                  className="rt-tr"
                  style={{ minWidth: defaultWidth + 'px' }}
                >
                  {headerGroup.headers.map((column, key) => (
                    <th
                      {...column.getHeaderProps()}
                      className={classnames('rt-th rt-resizable-header', {
                        '-cursor-pointer': headerGroup.headers.length !== key,
                        '-sort-asc': column.isSorted && !column.isSortedDesc,
                        '-sort-desc': column.isSorted && column.isSortedDesc,
                      })}
                      style={{ ...getCellStyle(key), textAlign: key === 0 ? 'center' : undefined }}
                    >
                      <div
                        className="rt-resizable-header-content"
                        {...column.getSortByToggleProps()}
                      >
                        {column.render('Header')}
                      </div>
                      {/* Render the columns filter UI */}
                      {filter ? (
                        <div
                          className="maxWidth: 80px"
                          onClick={() => {
                            handlePageSelect(0);
                          }}
                        >
                          {headerGroup.headers.length === key
                            ? null
                            : column.canFilter
                            ? column.render('Filter')
                            : null}
                        </div>
                      ) : (
                        ''
                      )}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
          ) : null}
          <tbody {...getTableBodyProps()} className="rt-tbody">
            {page.length < 1 ? (
              <tr
                className={classnames('rt-tr', { ' -odd': 0 === 0 }, { ' -even': 1 === 1 })}
                style={{
                  minWidth: defaultWidth + 'px',
                }}
              >
                <td
                  className="rt-td"
                  style={{
                    textAlign: 'left',
                  }}
                >
                  No se encontraron resultados...
                </td>
              </tr>
            ) : (
              page.map((row, i) => {
                prepareRow(row);
                return (
                  <tr
                    {...row.getRowProps()}
                    className={classnames(
                      'rt-tr',
                      { ' -odd': i % 2 === 0 },
                      { ' -even': i % 2 === 1 },
                    )}
                    style={{
                      minWidth: defaultWidth + 'px',
                      height: heightRow + 'px',
                      background:
                        typeof colorRow === 'function' ? colorRow(data[row.id]) : colorRow,
                    }}
                  >
                    {row.cells.map((cell, i) => {
                      return (
                        <td {...cell.getCellProps()} className="rt-td" style={getCellStyle(i)}>
                          {cell.render('Cell')}
                        </td>
                      );
                    })}
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
        <div className="pagination-bottom"></div>
      </div>
    </>
  );
}

// Define a custom filter filter function!
function filterGreaterThan(rows, id, filterValue) {
  return rows.filter((row) => {
    const rowValue = row.values[id];
    return rowValue >= filterValue;
  });
}

// This is an autoRemove method on the filter function that
// when given the new filter value and returns true, the filter
// will be automatically removed. Normally this is just an undefined
// check, but here, we want to remove the filter if it's not a number
filterGreaterThan.autoRemove = (val) => typeof val !== 'number';
